//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <div v-show="value" class="go_modal_container">
    <div class="go_modal_mask">
      <div class="go_modal_wrapper">
        <div class="modal_header">
          {{ store.state.page.before_we_start.header }}
        </div>
        <div class="modal_body">
          <div class="main_body">
            {{ store.state.page.before_we_start.body }}
          </div>
          <ul>
            <br />
            <li>
              <div class="dot"></div>
              {{ store.state.page.before_we_start.age_condition }}
            </li>
            <br />
            <li>
              <div class="dot"></div>
              {{ store.state.page.before_we_start.use_glasses_condition }}
            </li>
            <br />
            <li>
              <div class="dot"></div>
              {{ store.state.page.before_we_start.multifocal_condition }}
            </li>
          </ul>
        </div>
        <div class="modal_footer">
          <slot name="footer">
            <div class="close_button btn" @click="exit">
              {{ store.state.page.before_we_start.back_button }}
            </div>
            <div class="accept_button btn" @click="closePopUp">
              {{ store.state.page.before_we_start.ok_button }}
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from "vue";
import { useStore } from "vuex";
const props = defineProps({ show: Boolean, value: { required: true } });
const store = useStore();
const emit = defineEmits(["input", "close"]);

function closePopUp() {
  emit("input", !props.value);
}

function exit() {
  emit("close");
}
</script>

<style lang="scss" scoped>
.go_modal_container {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(21, 25, 46, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .go_modal_mask {
    width: 744px;
    height: 678px;
    justify-content: center;
    mix-blend-mode: normal;
    border-radius: 21px;
    z-index: 1;
    transition: opacity 0.3s ease;
    top: 10em;
    padding: 20px 30px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    justify-content: center;
    position: fixed;

    .go_modal_wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      font-family: "Lexend";

      .modal_header {
        text-align: left;
        height: 79px;
        padding: 20px 10px;
        font-family: "Lexend";
        font-style: normal;
        font-weight: 700;
        font-size: 54.75px;
        line-height: 63px;
        display: flex;
        align-items: flex-start;
        color: #18194c;
        justify-content: flex-start;
      }

      .modal_body {
        top: 174px;
        width: 100%;
        align-items: start;
        align-content: start;

        ul {
          list-style: none;
          text-align: left;
          padding: 40px 10px;
          font-family: "Lexend";
          font-style: normal;
          font-weight: 300;
          font-size: 30px;
        }

        .main_body {
          height: 62px;
          width: 90%;
          padding: 20px 10px;
          font-family: "Lexend";
          font-style: normal;
          font-weight: 300;
          font-size: 30.4167px;
          line-height: 38px;
          display: flex;
          align-items: flex-start;
          text-align: left;
          color: #15192e;
          justify-content: center;
        }

        .dot {
          align-items: start;
          width: 15px;
          height: 15px;
          top: 124px;
          background: #008bf0;
          border-radius: 50%;
          display: inline-block;
          margin-right: 20px;
        }
      }

      .modal_footer {
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        align-items: flex-end;
        margin-top: 12px;

        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 42.3243px;
          font-family: "Lexend";
          font-style: normal;
          font-weight: 400;
          font-size: 27px;
          line-height: 32px;
          text-align: center;
          letter-spacing: -0.166652px;
          color: #ffffff;
          width: 258px;
          height: 65px;

          &.accept_button {
            left: 423px;
            right: 8.38%;
            top: 562px;
            bottom: 7.4%;
            background: #008bf0;
            border-radius: 42.3243px;
          }

          &.close_button {
            left: 60px;
            right: 55.69%;
            top: 562px;
            bottom: 7.4%;
            background: #15192e;
          }
        }
      }
    }
  }
}
</style>
